import React from 'react'
import { useTranslation } from 'react-i18next'
import { Center, HStack } from '@chakra-ui/react'
import { SocialButtons } from 'components'
import { FaUserPlus } from 'react-icons/fa'
import { VscSignIn } from 'react-icons/vsc'
import { useHistory } from 'react-router'
import { PrimaryButton } from 'components/Buttons'

type SignSuggestionProps = {}

const SignSuggestion: React.FC<SignSuggestionProps> = ({}) => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <>
      <HStack width="100%" px={6} my={6}>
        <PrimaryButton
          width="100%"
          my={2}
          onClick={() => history.push('/login')}
          colorScheme="blue"
          leftIcon={<VscSignIn />}
          size="md"
        >
          {t('sign_in')}
        </PrimaryButton>
        <PrimaryButton
          width="100%"
          my={2}
          onClick={() => history.push('/register')}
          colorScheme="green"
          leftIcon={<FaUserPlus />}
          size="md"
        >
          {t('sign_up')}
        </PrimaryButton>
      </HStack>
      <Center flex={1} px={6} height="100%" width="100%" flexDirection="column">
        <SocialButtons />
      </Center>
    </>
  )
}

export default SignSuggestion
